import { render, staticRenderFns } from "./MiniAppList.vue?vue&type=template&id=dfed2174&scoped=true"
import script from "./MiniAppList.vue?vue&type=script&lang=js"
export * from "./MiniAppList.vue?vue&type=script&lang=js"
import style0 from "./MiniAppList.vue?vue&type=style&index=0&id=dfed2174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfed2174",
  null
  
)

export default component.exports